import mrfLogo from '../../assets/img/MRF-logo-copertina-tricolore.png'

export default mrfLogo
